@if (articleData) {
	<tk-article-content [previewData]="articleData!" [previewContent]="articleContent" />
}
